/* */ 
exports.f = {}.propertyIsEnumerable;
